"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _utils = require("../utils");
var UNIT_DAY = 'day';
var UNIT_MONTH = 'month';
var UNIT_CURRENT_MONTH = 'currentMonth';
var _default = exports["default"] = function _default(_ref) {
  var value = _ref.value,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    maxRange = _ref.maxRange,
    unit = _ref.unit;
  return (0, _react.useMemo)(function () {
    var selectedDate = value === null || value === void 0 ? void 0 : value[0];
    if (!maxRange || !selectedDate || (value === null || value === void 0 ? void 0 : value.length) === 2) {
      return {
        minDate: minDate,
        maxDate: maxDate
      };
    }
    switch (unit) {
      case UNIT_CURRENT_MONTH:
        return {
          minDate: (0, _utils.max)([minDate, (0, _utils.startOfMonth)(selectedDate)]),
          maxDate: (0, _utils.min)([maxDate, (0, _utils.endOfMonth)(selectedDate)])
        };
      case UNIT_MONTH:
        return {
          minDate: (0, _utils.max)([minDate, (0, _utils.subMonths)(selectedDate, maxRange)]),
          maxDate: (0, _utils.min)([maxDate, (0, _utils.addMonths)(selectedDate, maxRange)])
        };
      case UNIT_DAY:
      default:
        return {
          minDate: (0, _utils.max)([minDate, (0, _utils.subDays)(selectedDate, maxRange)]),
          maxDate: (0, _utils.min)([maxDate, (0, _utils.addDays)(selectedDate, maxRange)])
        };
    }
  }, [value, minDate, maxDate, maxRange, unit]);
};